import React from 'react'

type TGlobalState = {
    session: boolean;
    animation: boolean;
};

export const GlobalStateContext = React.createContext<TGlobalState>({session: false,animation: false});